import { CubeRequestConfig } from '../../../common/interface/cube-request-config.interface';

export interface GetSelfAppAveragesSummaryRequestDto {
  params: {
    endDate: string;
    appId: string;
  };
  config: CubeRequestConfig;
}
